import React from "react";

import { useContentContext } from "../context/content-context";

import ThemedPageWrapper from "./themed-page-wrapper";
const PatientTestimonialPage = () => {
  const { content, testimonials, isHCP } = useContentContext();

  return (
    <ThemedPageWrapper>
      <section className={isHCP ? "section-outer pt-15" : "section-outer pt-7"}>
        <div className={isHCP ? "section-inner mb-0" : "section-inner"}>
          <div className="column-container flex-wrap">
            {testimonials
              ?.reverse()
              .map(({ name, subtitleHCP, subtitlePatient, thumbnail, url }) => {
                return (
                  <div key={name} className="half mt-35">
                    <div className="video-thumbnail-container">
                      <img alt="" role="presentation" src={thumbnail} />
                      <a
                        href={`${isHCP ? "/hcp" : ""}/${
                          url.split("/").slice(-1)[0]
                        }`}
                        className="video-thumbnail-overlay testimonial-link"
                      >
                        <h2
                          className={`white mulish sentence-case mb-0 testimonial-title ${
                            isHCP ? "hcp" : ""
                          }`}
                        >
                          Hear {name}'s story
                        </h2>

                        <p
                          className={`white testimonial-copy ${
                            isHCP ? "hcp" : ""
                          }`}
                        >
                          <em>{isHCP ? subtitleHCP : subtitlePatient}</em>
                        </p>
                      </a>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </section>
      <div dangerouslySetInnerHTML={{ __html: content?.join("") }} />
    </ThemedPageWrapper>
  );
};

export default PatientTestimonialPage;
